import React, { ReactElement, memo } from 'react';
import { Result, Button, Paragraph, ResultVariants } from '@dexma/ui-components';
import i18n from 'asset/translation';
import AddFirstWidget from 'asset/images/addFirstWidget.svg';
import { StyledAddFirstWidgetResult } from 'adapter/in/dashboards/pages/EditDashboard/AddFirstWidgetResult/style';

export type AddFirstWidgetResultProps = {
    onAddWidget: () => void;
};

const AddFirstWidgetResult = (props: AddFirstWidgetResultProps): ReactElement => {
    const { onAddWidget } = props;

    return (
        <Result
            variant={ResultVariants.DEFAULT}
            data-testid='add-first-widget-result'
            title={i18n.t('dashboards.addFirstWidgetResult.title')}
            iconElement={<AddFirstWidget />}
            content={
                <StyledAddFirstWidgetResult>
                    <Paragraph className='content'>{i18n.t('dashboards.addFirstWidgetResult.content')}</Paragraph>
                    <Paragraph className='upto'>{i18n.t('dashboards.addFirstWidgetResult.upTo')}</Paragraph>
                    <Paragraph className='subcontent'>{i18n.t('dashboards.addFirstWidgetResult.subcontent')}</Paragraph>
                    <div>
                        <Button
                            kind='iconTextButton'
                            className='add-widget-button'
                            onClick={onAddWidget}
                            variant='primary'
                            iconBefore='add'
                            text={i18n.t('dashboards.addFirstWidgetResult.button')}
                            data-testid='add-widget-button'
                        />
                    </div>
                </StyledAddFirstWidgetResult>
            }
        />
    );
};

export default memo(AddFirstWidgetResult);
